import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ENV, StorageHelper } from "../helpers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PostAddIcon from "@mui/icons-material/PostAdd";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Chip from "@mui/material/Chip";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  IconButton,
  Tooltip,
  CircularProgress,
  Tab,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import { download, generateCsv, mkConfig } from "export-to-csv";
import {
  MRT_GlobalFilterTextField,
  useMaterialReactTable,
} from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AlertDialog,
  MgpButton,
  MgpModal,
  MgpRadioButton,
  MgpTable,
  MgpTableStatus,
  MgpText,
  MgpTextbox,
  TableConfig,
} from "../components/global";
import { usePatient, useRbac } from "../hooks";
import { colors } from "../theme/colors";
import { VerifyPatient } from "./VerifyPatient";
import Loader from "./Loader/Loader";
import { MgpChip } from "../components/global/MgpChip";
import StatusColors from "../components/global/StatusColors";
import { PatientReject } from "./PatientApproval/PatientReject";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import FlagIcon from "@mui/icons-material/Flag";
import { downloadPdf } from "../helpers/dowloadPdf";

import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { downloadExcel } from "../helpers/downloadExcel";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

let radioButtonList = [
  { value: "1", label: "Ready to Review" },
  { value: "2", label: "Reviewed" },
  { value: "3", label: "Rejected" },
];

const columnStickyStyle = {
  position: "sticky",
  left: 0,
  right: 0,
  zIndex: 10,
};

export const HomeDashboard = () => {
  const { RbacWrapper, rbac } = useRbac();
  const [open, setOpen] = React.useState(false);
  const [openTransfer, setOpenTransfer] = React.useState(false);
  const [patientData, setData] = React.useState({ columns: [], rows: {} });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const handleOpenTransfer = () => {
    setTimeout(() => {
      navigate(`transfer`);
    }, 1000);
  };
  const handleCloseTransfer = () => setOpenTransfer(false);
  const [filterStatus, setFilterStatus] = React.useState("");
  const [tableData, setTableData] = useState([]);
  const selectItem = (item) => {
    setFilterStatus(item);
    setTableData(
      data?.GetPatients.filter(
        (elem) => parseInt(elem.status_value) === parseInt(item)
      ) ?? []
    );
  };
  const userDetails = JSON.parse(StorageHelper.get("user"));
  const hidePiiColumns = userDetails?.collect_pii === false;
  const withoutPiiColumns = (cols) =>
    hidePiiColumns
      ? cols.filter(
          (col) =>
            ![
              "edit_basic",
              "mrn_no",
              "national_id",
              "first_name",
              "email",
              "mobile",
              "consentform",
            ].includes(col?.accessorKey)
        )
      : cols;
  const [value, setValue] = useState("1");

  const [delete_ref, setDeleting] = React.useState(false);
  const { useGetPatients, useDeletePatient } = usePatient();
  const [tableLoading, setTableLoading] = useState(true);
  const [openDeletePatient, setOpenDeletePatient] = useState(false);
  const [patientid, setPatientId] = useState(0);
  // const { RbacWrapper } = useRbac();
  const [GetPatients, { data, loading: patientLoading, error }] =
    useGetPatients;
  const [DeletePatient] = useDeletePatient;

  const CustomFilterTextField = ({ column }) => {
    console.log("The custom Filter component is called", column);
    return (
      <TextField
        variant="outlined"
        size="small"
        value={column.getFilterValue() || ""}
        onChange={(event) => column.setFilterValue(event.target.value)}
        placeholder={`Search by ${column.columnDef.header}`}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px",
            backgroundColor: "#ffffff", // Set background color to white
            border: "1px solid black", // Add 1px solid black border
            "& fieldset": {
              borderColor: "black", // Ensure the border color is black
            },
            "&:hover fieldset": {
              borderColor: "red",
            },
            "&.Mui-focused fieldset": {
              borderColor: "black",
            },
          },
          "& .MuiInputBase-input": {
            padding: "6px 8px",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "grey", // Change placeholder text color if needed
            opacity: 1,
          },
        }}
      />
    );
  };
  let columns = [
    {
      accessorKey: "edit_basic",
      header: "Edit Patient Basic Information",
      textAlign: "center",
      size: 170,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        return (
          <>
            <Tooltip title={"edit patient profile"} arrow>
              <IconButton
                sx={{ padding: "2px" }}
                component="a"
                href={"Edit/" + row?.original?.encounter_id}
                target="_blank"
                rel="noopener noreferrer"
              >
                <EditIcon
                  sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      accessorKey: "view_report",
      header: "Reports",
      textAlign: "center",
      enableColumnFilter: false,
      Cell: ({ row }) => {
        return (
          <>
            {row?.original?.encounter_id ? (
              <Tooltip title="view all reports" arrow>
                <IconButton
                  sx={{ padding: "2px" }}
                  component="a"
                  href={"viewPatient/" + row?.original?.patient_id}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ThermostatIcon
                    sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                  />
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      accessorKey: "reports",
      header: "View and Edit Reports",
      headerAlign: "center",
      textAlign: "center",
      size: 130,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        return (
          <>
            {row?.original?.encounter_id ? (
              <Tooltip title="view all reports" arrow>
                <IconButton
                  sx={{ padding: "2px" }}
                  component="a"
                  href={"viewPatient/" + row?.original?.patient_id}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ViewAgendaIcon
                    sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                  />
                </IconButton>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      accessorKey: "totalVisits", //normal accessorKeyuse
      header: "Number Of Reports",
      headerAlign: "center",
      size: 50,
      Cell: ({ renderedCellValue, row }) => {
        return row.original.baseline ? (
          <Tooltip
            title={`Baseline Visit:${row.original.baseline}, Follow Up Visit:${row.original.followup}`}
            arrow
          >
            <span>{renderedCellValue}</span>
          </Tooltip>
        ) : (
          <>{renderedCellValue}</>
        );
      },
    },
    {
      accessorKey: "follow_up_count",
      header: "Number Of Follow ups ",
      size: 150,
    },
    {
      accessorKey: "mrn_no", //normal accessorKey
      header: "MRN No.",
      headerAlign: "center",
      size: 150,
    },
    {
      accessorKey: "registry_no",
      header: "Registry Number",
      headerAlign: "center",
      Cell: ({ row }) => {
        let shouldRenderIcon = row.original.is_transferred;

        return (
          <Box
            sx={{
              // display: "flex",
              // alignItems: "center",
              textDecoration: "underline",
              color: colors.PRIMARY,
            }}
            component="a"
            href={"viewPatient/" + row?.original?.patient_id}
            target="_blank"
          >
            {row.original?.reminder_flag &&
              row.original?.reminder_flag === 1 && (
                <Tooltip title={row.original?.reminder_flag_enum} arrow>
                  <FlagIcon
                    sx={{
                      fontSize: "16px",
                      color: "#FFC107",
                    }}
                  />
                </Tooltip>
              )}
            {row.original?.reminder_flag &&
              row.original?.reminder_flag === 2 && (
                <Tooltip title={row.original?.reminder_flag_enum} arrow>
                  <FlagIcon
                    sx={{
                      fontSize: "16px",
                      color: "#F44336",
                    }}
                  />
                </Tooltip>
              )}
            {row.original.registry_no}
            {shouldRenderIcon ? (
              <Tooltip title="patient transferred" arrow>
                <CompareArrowsIcon sx={{ fontSize: "16px" }} />
              </Tooltip>
            ) : (
              <></>
            )}
          </Box>
        );
      },
    },
    {
      accessorKey: "national_id", //normal accessorKey
      header: "Patient National ID",
      headerAlign: "center",
      Cell: ({ row }) =>
        row.original?.pii_collected === false
          ? "-"
          : row.original?.national_id,
    },
    {
      accessorKey: "first_name", //normal accessorKey
      header: "Patient Name",
      headerAlign: "center",
    },
    {
      accessorKey: "form_completed", //normal accessorKey
      header: "Form Completed By",
      headerAlign: "center",
    },
    {
      accessorKey: "status", //normal accessorKey
      header: "Last Visit Status",
      muiTableHeadCellProps: {
        sx: {
          ...TableConfig.muiTableHeadCellProps.sx,
          position: "sticky",
          left: 0, // Use left to position the sticky column on the left
          right: 0,
          zIndex: 10, // Ensure it's above other columns
          borderRight: "1px solid #ccc",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          ...TableConfig.muiTableBodyCellProps.sx,
          position: "sticky",
          left: 0, // Same left positioning
          right: 0,
          zIndex: 10, // Same zIndex for consistency
          borderRight: "1px solid #ccc",
        },
      },

      headerAlign: "center",
      Cell: ({ row }) => (
        <div style={columnStickyStyle}>
          <Box>
            <MgpTableStatus
              value={row.original.status_value}
              label={row.original.status}
            />
          </Box>
        </div>
      ),
    },
    {
      accessorKey: "doctor_name", //normal accessorKey
      header: "Doctor Name",
      headerAlign: "center",
    },
    {
      accessorKey: "hospital_name", //normal accessorKey
      header: "Hospital Name",
      headerAlign: "center",
      size: 310,
    },
    {
      accessorKey: "hospital_code", //normal accessorKey
      header: "Hospital Code",
      headerAlign: "center",
    },
    {
      accessorKey: "hospital_city", //normal accessorKey
      header: "Hospital City",
      headerAlign: "center",
    },

    {
      accessorKey: "created_on",
      header: "Creation Date",
      headerAlign: "center",
      Cell: ({ row }) => {
        return (
          <>
            {new Date(parseInt(row.original.created_on)).toLocaleDateString(
              "en-GB"
            )}
          </>
        );
      },
    },
    {
      accessorKey: "firstVisit", //normal accessorKey
      header: "Baseline Visit Date",
      headerAlign: "center",
      size: 100,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.firstVisit
              ? new Date(row.original.firstVisit).toLocaleDateString("en-GB")
              : ""}
          </>
        );
      },
    },
    {
      accessorKey: "lastVisit", //normal accessorKey
      header: "Last Visit Report Date",
      headerAlign: "center",
      size: 150,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.lastVisit
              ? new Date(row.original.lastVisit).toLocaleDateString("en-GB")
              : ""}
          </>
        );
      },
    },
    {
      accessorKey: "updated_on",
      header: "Last Action Date",
      headerAlign: "center",
      size: 100,
      Cell: ({ row }) => {
        return (
          <>
            {new Date(parseInt(row.original.updated_on)).toLocaleDateString(
              "en-GB"
            )}
          </>
        );
      },
    },
    {
      accessorKey: "created_by_name",
      header: "Created By",
      headerAlign: "center",
    },
    {
      accessorKey: "updated_by_name",
      header: "Last Action Done By",
      headerAlign: "center",
    },
    {
      accessorKey: "email",
      header: "Email",
      headerAlign: "center",
    },
    {
      accessorKey: "mobile",
      header: "Phone Number",
      headerAlign: "center",
    },
    {
      accessorKey: "gender",
      header: "Gender",
      headerAlign: "center",
    },
    {
      accessorKey: "consentform",
      header: "Informed Consent Form",
      enableColumnFilter: false,
      size: 150,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.consentform ? (
              <Box>
                <Tooltip
                  title={
                    userDetails?.role_id == ENV.doctor_role_id ||
                    userDetails?.role_id == ENV.medical_lead_role_id
                      ? "Download Informed Consent Form"
                      : ""
                  }
                >
                  {userDetails?.role_id == ENV.doctor_role_id ? (
                    <a
                      href={`${ENV.file_download_url}/${row.original.consentform}`}
                      download={row.original.consentform}
                    >
                      <IconButton size="small">
                        <DoneIcon
                          sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                        />
                      </IconButton>
                    </a>
                  ) : userDetails?.role_id == ENV.medical_lead_role_id &&
                    value == 1 ? (
                    <a
                      href={`${ENV.file_download_url}/${row.original.consentform}`}
                      download={row.original.consentform}
                    >
                      <IconButton size="small">
                        <DoneIcon
                          sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                        />
                      </IconButton>
                    </a>
                  ) : (
                    <IconButton size="small">
                      <DoneIcon
                        sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                      />
                    </IconButton>
                  )}
                </Tooltip>
              </Box>
            ) : (
              <Box>
                <Tooltip
                  title={
                    userDetails?.role_id == ENV.doctor_role_id ||
                    userDetails?.role_id == ENV.medical_lead_role_id
                      ? "No Informed Consent Form"
                      : ""
                  }
                >
                  <IconButton size="small">
                    <CloseIcon
                      sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </>
        );
      },
    },
    {
      accessorKey: "action",
      header: "Action",
      Cell: ({ row }) => {
        return (
          <Box>
            <>
              {/* <RbacWrapper module={"patients"} code={"view_patient"}>

                {row?.original?.status !== "Draft" && ( */}
              <RbacWrapper module={"patients"} code={"view_patient"}>
                <Tooltip title={"visit all patient report"} arrow>
                  <IconButton
                    sx={{ padding: "2px" }}
                    component="a"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={"viewPatient/" + row?.original?.patient_id}
                  >
                    <VisibilityOutlinedIcon
                      sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                    />
                  </IconButton>
                </Tooltip>
              </RbacWrapper>
              {/* )}
              </RbacWrapper> */}
              <RbacWrapper module={"patients"} code={"delete"}>
                <Tooltip title={"Delete Patient"} arrow>
                  <IconButton
                    sx={{ padding: "2px" }}
                    onClick={() => {
                      handleDelete(row.original);
                    }}
                  >
                    <DeleteIcon
                      sx={{ height: "16px", color: colors.MENULISTPRIMARY }}
                    />
                  </IconButton>
                </Tooltip>
              </RbacWrapper>
            </>
          </Box>
        );
      },
    },
  ];
  const handleChange = (event, newValue) => {
    setTableData([]);
    setValue(newValue);
  };

  const filteredColumns = useMemo(() => {
    const pickColumns = (tableKey) =>
      (rbac?.tables?.[tableKey] ?? [])
        .map((key) => columns.find((col) => col.accessorKey === key))
        .filter(Boolean);
    if (value === "2") {
      return withoutPiiColumns(
        pickColumns("patient_table_other_doctor")
          .filter(
            (elem) =>
              !["mrn_no", "national_id", "first_name"].includes(
                elem.accessorKey
              )
          )
          .map((elem) =>
            elem.accessorKey === "reports"
              ? { ...elem, header: "View Reports", size: 250 }
              : elem
          )
      );
    }
    return withoutPiiColumns(pickColumns("patient_table"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rbac, value, hidePiiColumns]);

  useEffect(() => {
    GetPatients({
      variables:
        value === "2" ? { isActive: true, self: false } : { isActive: true },
      fetchPolicy: "cache-and-network",
    });
  }, [GetPatients, value]);

  useEffect(() => {
    if (data) setTableData(data.GetPatients ?? []);
  }, [data]);

  const isLoading =
    !filteredColumns.length ||
    (!tableData?.length && !error && (patientLoading || !data));

  const table = useMaterialReactTable({
    columns: filteredColumns,
    data: tableData ?? [],
    ...TableConfig,
    initialState: {
      ...TableConfig.initialState,
      columnPinning: {
        right: ["action"],
      },
    },
    enableRowActions: false,
    // icons: {
    //   ArrowDownwardIcon: () => <ViewAgendaIcon />,
    // },
    // enableColumnResizing: true,
    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          display: "flex",
          gap: "0.5rem",
          p: "16px 0px",
          justifyContent: "space-between",
        })}
      >
        <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <MRT_GlobalFilterTextField table={table} />
        </Box>
        <Box sx={{ display: "flex", gap: "16px" }}>
          {value === "1" ? (
            <RbacWrapper module={"patients"} code={"add"}>
              {!StorageHelper.get("subinvestigator_id") || StorageHelper.get("subinvestigator_id") === "" ? (
              <MgpButton
                onClick={handleOpen}
                variant="contained"
                // sx={{fontSize:"13px"}}
                endIcon={
                  <PersonAddIcon
                    sx={{ marginTop: "-3px", fontSize: "16px !important" }}
                  />
                }
              >
                Add Patient
              </MgpButton>) : (
                <></>
              )}
            </RbacWrapper>
          ) : (
            <></>
          )}

          {/* <RbacWrapper module={"patients"} code={"filter"}>
            <MgpRadioButton
              value={filterStatus}
              onChange={selectItem}
              list={radioButtonList}
            ></MgpRadioButton>
            <MgpButton
              onClick={() => {
                setFilterStatus("");
                setTableData(data?.GetPatients);
              }}
              variant="contained"
            >
              Clear Filter
            </MgpButton>
          </RbacWrapper> */}
          {/* <RbacWrapper module={"patients"} code={"patient_transfer"}>
            <MgpButton
              variant="contained"
              onClick={handleOpenTransfer}
              endIcon={
                <TransferWithinAStationIcon sx={{ marginTop: "-3px" }} />
              }
            >
              Transferred List
            </MgpButton>
          </RbacWrapper> */}
          <RbacWrapper module={"patients"} code={"export"}>
            <MgpButton
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => handleExportData("xlsx")}
              variant="contained"
              endIcon={
                <FileDownloadIcon sx={{ fontSize: "16px !important" }} />
              }
            >
              Export Excel
            </MgpButton>
            <MgpButton
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() => handleExportData("pdf")}
              variant="contained"
              endIcon={
                <FileDownloadIcon sx={{ fontSize: "16px !important" }} />
              }
            >
              Export PDF
            </MgpButton>
          </RbacWrapper>
        </Box>
      </Box>
    ),
    muiSearchTextFieldProps: ({ table }) => {},

    state: {
      isLoading,
      columnOrder: filteredColumns.map((e) => e.accessorKey),
    },
    renderTableBody: () => {
      return isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : null;
    },
  });
  const handleExportData = (type) => {
    const filteredData = table
      .getFilteredRowModel()
      .rows.map((row) => row.original)
      .map((obj) => {
        const filteredObj = {};
        filteredColumns.forEach((key) => {
          if (obj.hasOwnProperty(key.accessorKey)) {
            if (
              key.header === "Baseline Visit Date" ||
              key.header === "Last Visit Report Date"
            ) {
              filteredObj[key.header] = obj[key.accessorKey]
                ? new Date(obj[key.accessorKey]).toLocaleDateString("en-GB")
                : null;
            } else if (key.header === "Informed Consent Form") {
            } else if (
              key.header === "Creation Date" ||
              key.header === "Last Action Date"
            ) {
              filteredObj[key.header] = new Date(
                parseInt(obj[key.accessorKey])
              ).toLocaleDateString("en-GB");
            } else {
              filteredObj[key.header] = obj[key.accessorKey];
            }
          }
        });
        return filteredObj;
      });

    let dataToExport = filteredData.length ? filteredData : data.rows;
    let filename = "Patient List";

    if (dataToExport.length) {
      if (type === "xlsx") {
        downloadExcel(dataToExport, filename);
      } else {
        downloadPdf(dataToExport, filename);
      }
    }
  };

  const handleDelete = (row) => {
    setOpenDeletePatient(true);
    setPatientId(row.patient_id);
  };

  if (!rbac) {
    return <Loader open={true} />;
  }
  const statuses = [
    {
      label:
        "Draft - Indicates the incompletion of the record, i.e. missing information and entries are still yet to be completed.",
      value: "0",
    }, // Draft - Amber
    {
      label:
        "Ready to Review - Indicates data entry and record completion and is ready to be reviewed by the “Monitor / QC”. Data here refers to the mandatory data / required.",
      value: "1",
    }, // Ready to Review - Green
    {
      label:
        "Reviewed - Indicates that the “Monitor” has reviewed the record and approved it.",
      value: "2",
    }, // Reviewed - Light Green
    {
      label:
        "Return to Doctor - Indicates that the comments / concerns raised by the “Monitor” on the record are pending / awaiting to be addressed / amended by the “PI / Doctor.”",
      value: "4",
    }, // Return to Doctor - Gray
    {
      label:
        "Re-opened - Indicates that the “Reviewed” report is reopened by quality user to edit and modify information.",
      value: "6",
    },
  ];

  return (
    <>
      {delete_ref && (
        <AlertDialog
          open={true}
          negative={() => {
            setDeleting(false);
          }}
          positive={(param) => {
            DeletePatient({ variables: { patientId: Number(param) } });
          }}
          param={delete_ref}
          title={"Delete"}
          description={"Are you sure you want to delete?"}
        />
      )}

      <RbacWrapper module={"patients"} code={"patient_list_medical_lead"}>
        <Box sx={{ width: "100%", typography: "body1", marginBottom: "1%" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} variant="fullWidth">
                <Tab
                  label="My Patient List"
                  value="1"
                  sx={{
                    fontSize: "12px",
                    fontWeight: value === "1" ? 800 : 700,
                    // backgroundColor: colors.PRIMARY_LIGHT,
                    // color: "white",
                    // '&.Mui-selected': {
                    //   backgroundColor: colors.PRIMARY_DARK,
                    // },
                    // '&:hover': {
                    //   backgroundColor: colors.PRIMARY_LIGHT,
                    // }
                  }}
                />
                <Tab
                  label="Hospital Patient List"
                  value="2"
                  sx={{
                    fontSize: "12px",
                    fontWeight: value === "2" ? 800 : 700,
                    // backgroundColor: colors.PRIMARY_LIGHT,
                    // color: colors.PRIMARY_TEXT,
                    // '&.Mui-selected': {
                    //   backgroundColor: colors.PRIMARY_DARK,
                    // },
                    // '&:hover': {
                    //   backgroundColor: colors.PRIMARY_LIGHT,
                    // }
                  }}
                />
              </TabList>
            </Box>
          </TabContext>
        </Box>
      </RbacWrapper>

      <Box>
        <MgpText variant="h5">PATIENT LIST</MgpText>
        <MgpTable table={table} />
        <StatusColors statuses={statuses}></StatusColors>
        <MgpModal
          open={open}
          handleOpen={handleOpen}
          onClose={handleClose}
          title={"Register a new patient"}
          styling={{ width: "min(520px, 92vw)", minWidth: 360 }}
        >
          <VerifyPatient />
        </MgpModal>
      </Box>
      <MgpModal
        open={openDeletePatient}
        onClose={() => {
          setOpenDeletePatient(false);
        }}
      >
        <PatientReject
          reject={openDeletePatient}
          setOpenReject={setOpenDeletePatient}
          messageHeading={
            "Are you sure to delete this patient report? If yes, all records will be deleted too. Please add the deletion reason."
          }
          Delete={
            "Are you sure to delete this patient report? If yes, all records will be deleted too. Please add the deletion reason."
          }
          DeletePatient={DeletePatient}
          a
          patientid={patientid}
        />
      </MgpModal>
    </>
  );
};
